<template>
	
	<div class="well">
		
		<div v-if="title">
			<h2 v-if="!editMode">{{ subTitle }}</h2>
			<v-avatar v-if="!editMode && avatarLetter" class="avatar">{{ avatarLetter }}</v-avatar>
			<h1 v-if="!editMode" :style="supplement ? 'margin-bottom: 5px;' : 'margin-bottom: 30px;'">{{ title }}</h1>
			<v-text-field v-if="editMode" style="margin-bottom: 30px;"
				class="wellEditInput"
				v-model="newTitle"
				:placeholder="title"
				:flat="true"
				density="compact"
				variant="solo"
				hide-details
				single-line
				:bg-color="'var(--background-color-main)'"
			/>
			<h3 v-if="!editMode && supplement" style="margin-bottom: 30px;">{{ supplement }}</h3>
		</div>
		<v-row v-if="!data || data.length == 0">
			<v-col>
                <v-progress-linear height="2px" indeterminate></v-progress-linear>
			</v-col>
		</v-row>
		<v-row :class="editMode ? 'editMode' : ''" v-else-if="sortedData[0].label !== 'No data'" v-for="d in sortedData" :key="d.label" @click="handleClick(d)">
			<v-col>
				{{ d.label }} <span class="supplement" v-if="d.supplement">{{ d.supplement }}</span><br/>
				<template v-if="editMode">
					<v-text-field
						class="wellEditInput"
						v-model="d.value"
						:placeholder="d.value"
						:flat="true"
						density="compact"
						variant="solo"
						hide-details
						single-line
						:bg-color="'var(--background-color-main)'"
					/>
				</template>
				<template v-else>
					<span :class="{'moneyIn': d.moneyIn}">{{ d.value }} </span>
				</template>
				<br/>
				<v-row class="progressRow" v-if="d.progress">
					<v-col>
						<v-progress-linear :model-value="d.progress" rounded></v-progress-linear>
					</v-col>
				</v-row>
			</v-col>
		</v-row>

		<div class="editButtons" v-if="editMode">
			<MGButton alt="true" :small="false" :circle="true" icon="mdi-check" @click="$emit('save', this.newTitle)" />
		</div>

	</div>
	
</template>

<script>
import MGButton from './MGButton.vue';

export default {
	name: "WellPanel",
	components: {MGButton},
	props: ['title', 'subTitle', 'icon', 'avatarLetter', 'data', 'editMode', 'supplement'],
	emits: ['merchantClicked', 'save'], // TODO: merchantCLicked???
	data() {
		return{
			something: null,
			newTitle: this.title,
		}
	},
	computed: {
		somethingElse() {
			return null;
		},
		sortedData() {
            return this.data.slice().sort((a, b) => a.order - b.order);
        }
	},
	methods: {
		onLoad() {
		},
		handleClick(d) {
			this.$emit('merchantClicked', d);
		}
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>

h2 {
	font-size: 18px;
	font-weight: bold;
	margin-bottom: 0px;
	color: var(--grey-text);
}

h3 {
	font-size: 12px;
	margin-bottom: 0px;
	color: var(--grey-text);
}

h1{
	margin-top: 0px;
	font-size: 24px;
	font-weight: bold;
	margin-bottom: 30px;
}

.avatar {
	width: 50px;
	height: 50px;
	float: right;
	background-color: var(--background-color-alt2);
	margin-top: -20px;
	color: white;
	font-size: 24px;
}

.editPanel {
	text-align: right;
	font-size: 14px;
	margin-top: -30px;
	margin-bottom: 10px;
}

.well {
	
	color: var(--text-color);
	padding: 20px;
	background-color: white;
	border-radius: 8px;

	.v-row {
		padding-left: 15px;
		padding-right: 15px;
	}

	.v-col{
		padding: 0px;
		padding-bottom: 12px;
		padding-top: 12px;
		font-size: 12px;
		span {
			font-size: 14px;
			font-weight: bold;
		}
		.supplement {
			font-size: 10px;
			color: var(--grey-text);
		}
		border-bottom: 1px solid var(--border-color);
	}
	
	.editMode{
		.v-col {
			border-bottom: none;
			padding-top: 0px;
			padding-bottom: 0px;
		}
	}

	.v-row:last-child .v-col {
		border-bottom: 0px;
	}

	.progressRow {
		padding-top: 10px;
	}

	:deep(.v-progress-linear__background) {
		background-color: var(--border-color) !important;
	}

}

.wellEditInput {
	width: 100%;
}

.moneyIn {
	background-color: #23af6433;
	color: #23AF64;
	padding: 3px;
	border-radius: 3px;
}

.editButtons {
	position:fixed;
	bottom: 10%;
	right: 35px;
	margin-top: 20px;
	text-align: right;
}

</style>